  $(document).on("click", ".custom-rec-btn", function(){
    let variantId = $(this).parent().find(".custom-rec-variants").val();
    let arr = [];
    arr.push({'id': variantId, 'quantity': 1});
    ATCtoCartDrawer(arr, $(this));
  });
    function ATCtoCartDrawer(productsArr, $this){
        $this.addClass("active");
        let formData = {
            'items': productsArr
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then(res => {
            if(res.status){
              toastr.error(res.description);
            }
            else{
              document.dispatchEvent(new CustomEvent('cart:build'));
              $this.parents("swiper-slide").hide();
              jQuery.getJSON('/cart.js', function(cart) {  
                console.log(cart);
                $('#cart--count').text(cart.item_count);
      });    
    $('.cart__item--properties span').each(function() {
        var text = $(this).text();
        if (text.includes('Color:')) {
            var updatedText = text.replace('Color:', 'Kleur:');
            $(this).text(updatedText);
        }
    });
             
            }
        })
        .catch((error) => {
            console.error('Error test:', error);
        })
        .finally(() => {
            $this.removeClass("active");
        });
    }



$(document).ready(function() {
    $('.cart__item--properties span').each(function() {
        var text = $(this).text();
        if (text.includes('Color:')) {
            var updatedText = text.replace('Color:', 'Kleur:');
            $(this).text(updatedText);
        }
    });
});
